import { StyleSheet } from 'react-native'
import * as Colors from '@themes/Colors'
import Fonts from '@themes/Fonts'
import * as Shadows from '@themes/Shadows'

const innerCard = {
  marginTop: 22,
  paddingVertical: 18,
  paddingHorizontal: 15,
  color: 'rgb(255, 255, 255)',
  borderRadius: 10,
  borderWidth: 2,
  borderColor: 'rgba(255,255,255,0.5)',
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  //GoalMetricCard
  innerCard: {
    ...innerCard,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderStyle: 'dashed',
  },
  topRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  innerCardActive: {
    ...innerCard,
    backgroundColor: Colors.white,
  },
  labelActive: {
    fontFamily: Fonts.type.bold,
    fontSize: 17,
    color: Colors.textGray,
    paddingBottom: 10,
  },
  label: {
    fontFamily: Fonts.type.regular,
    fontSize: 17,
    color: Colors.white,
  },
  progressBar: {
    height: 8,
    borderRadius: 4,
    backgroundColor: Colors.altWhite,
  },
  innerProgressBar: {
    height: 8,
    borderRadius: 4,
    backgroundColor: Colors.primary,
  },

  //GOAL Modal
  bottomModal: {
    justifyContent: 'flex-end',
    margin: 0,
  },
  modalContainer: {
    backgroundColor: Colors.white,
    padding: 22,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 4,
    borderColor: 'rgba(0, 0, 0, 0.1)',
  },
  //
  innerModalContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalTitle: {
    fontFamily: Fonts.type.bold,
    fontSize: Fonts.size.h5,
    marginVertical: 30,
  },
  innerModalTitle: {
    fontFamily: Fonts.type.bold,
    fontSize: Fonts.size.h5,
    textAlign: 'center',
  },
  modalText: {
    fontFamily: Fonts.type.regular,
    fontSize: 14,
    color: Colors.descriptionGray,
    paddingBottom: 4,
    lineHeight: 24,
    textAlign: 'center',
  },
  goalNumber: {
    color: Colors.alternateGray,
    fontFamily: Fonts.type.bold,
    fontWeight: 'bold',
    fontSize: 48,
  },
  row: {
    flexDirection: 'row',
  },
  controls: {
    flexDirection: 'row',
  },

  //TabSelect
  tabSelect: {
    width: 300,
    borderRadius: 10,
    borderWidth: 2,
    borderColor: Colors.neutralGray,
    marginVertical: 15,
    marginHorizontal: 15,
    paddingHorizontal: 5,
    position: 'relative',
    zIndex: 1,
    height: 44,
  },
  //FROM CARDSTATSTYLE
  tabLabel: {
    fontFamily: Fonts.type.regular,
    fontSize: 15,
    color: Colors.alternateGray,
    opacity: 0.6,
    paddingHorizontal: 15,
    paddingVertical: 10,
    width: 150,
  },

  tabLabelActive: {
    top: -1,
    width: 150,
    paddingHorizontal: 15,
    paddingVertical: 11,
    backgroundColor: Colors.white,
    ...Shadows.defaultShadow,
    borderRadius: 10,
    borderWidth: 2,
    borderColor: Colors.primary,
    position: 'absolute',
    zIndex: 2,
  },
  tabLabelActive_yearly: {
    right: -1,
  },
  tabLabelActive_monthly: {
    left: -1,
  },
  activeText: {
    fontFamily: Fonts.type.alternateBold,
    fontSize: 15,
    textAlign: 'center',
  },
  goalProgressMessage: {
    marginHorizontal: 2,
    fontSize: Fonts.size.regular,
    fontFamily: Fonts.type.regular,
    color: Colors.descriptionGray,
    marginBottom: 10,
  },
})

export default styles
